export class MenuUtils {
    static createInitialTraits(menuConfig) {
        const options = Object.entries(menuConfig).map(([key, value]) => ({
            name: key,
            value: key,
            items: value,
        }));

        return [
            {
                type: 'recursive-menu-sync-button',
                name: 'menu-sync-button',
                label: 'Menuliste synchronisieren',
                text: 'Menuliste synchronisieren',
            },
            {
                type: 'checkbox',
                name: 'show-sub-items-on-hover',
                label: 'Untermenü bei Hover anzeigen',
                valueTrue: 'true',
                valueFalse: 'false',
                value: 'false',
            },
            {
                type: 'recursive-menu-select',
                name: 'menu-level-1',
                label: 'Menu Level 1',
                options: options,
            },
        ];
    }

    static getCurrentMenuItems(attributes, menuConfig) {
        const menuLevels = this.getMenuLevels(attributes);

        if (menuLevels.length === 0) {
            return this.getRootMenuItems(menuConfig);
        }

        return this.traverseMenuHierarchy(attributes, menuLevels, menuConfig);
    }

    static getMenuLevels(attributes) {
        return Object.keys(attributes)
            .filter((key) => key.startsWith('menu-level-'))
            .sort((a, b) => {
                const levelA = parseInt(a.split('-')[2]);
                const levelB = parseInt(b.split('-')[2]);
                return levelA - levelB;
            });
    }

    static getRootMenuItems(menuConfig) {
        return Object.entries(menuConfig).map(([key, value]) => ({
            name: key,
            value: key,
            items: value,
            label: key,
        }));
    }

    static traverseMenuHierarchy(attributes, menuLevels, menuConfig) {
        let currentItems = this.getRootMenuItems(menuConfig);

        for (let i = 0; i < menuLevels.length; i++) {
            const levelKey = menuLevels[i];
            const levelValue = attributes[levelKey];

            if (!levelValue) break;

            const selectedItem = currentItems.find(
                (item) => item.value === levelValue
            );

            if (
                selectedItem &&
                selectedItem.items &&
                selectedItem.items.length > 0
            ) {
                currentItems = selectedItem.items.map((item) => ({
                    name: item.label || item.name || 'Unnamed',
                    value:
                        item.identifier || item.label || item.name || 'unnamed',
                    items: item.items || [],
                    label: item.label || item.name || 'Unnamed',
                }));
            } else {
                return selectedItem ? [selectedItem] : [];
            }
        }

        return currentItems;
    }

    static getMenuLevel(attributes) {
        const menuLevels = Object.keys(attributes).filter((key) =>
            key.startsWith('menu-level-')
        );
        return menuLevels.length;
    }

    static isComponentReady(component) {
        return (
            component.components && typeof component.components === 'function'
        );
    }

    static createTraitConfig(menuLevels, attributes, levelIndex, menuConfig) {
        const levelKey = menuLevels[levelIndex];
        const levelNumber = parseInt(levelKey.split('-')[2]);
        const currentOptions = this.getCurrentOptionsForLevel(
            menuLevels,
            attributes,
            levelIndex,
            menuConfig
        );

        return {
            type: 'recursive-menu-select',
            name: levelKey,
            label: `Menu Level ${levelNumber}`,
            options: currentOptions,
        };
    }

    static getCurrentOptionsForLevel(
        menuLevels,
        attributes,
        levelIndex,
        menuConfig
    ) {
        let currentOptions = this.getRootMenuItems(menuConfig);

        for (let i = 0; i < levelIndex; i++) {
            const levelKey = menuLevels[i];
            const levelValue = attributes[levelKey];

            if (levelValue) {
                const selectedItem = currentOptions.find(
                    (opt) => opt.value === levelValue
                );
                if (
                    selectedItem &&
                    selectedItem.items &&
                    selectedItem.items.length > 0
                ) {
                    currentOptions = selectedItem.items.map((item) => ({
                        name: item.label || item.name || 'Unnamed',
                        value:
                            item.identifier ||
                            item.label ||
                            item.name ||
                            'unnamed',
                        items: item.items || [],
                    }));
                }
            }
        }

        return currentOptions;
    }
}
